const factor = 1000;
const toKilogram = (value: number) => value * factor;
const toTon = (value: number) => value / factor;

export const castHelper = {
  toKilogram,
  toTon,
};
